import { useSelector } from "react-redux";
import { RootState } from "../store";
import { Scale } from "../pages/trainings/ExamView";
import { get, isNumber, set } from "lodash";

export const useChart = () => {

    const metric = useSelector<RootState>(state => state.user.user?.unit_system) as "metric" | "imperial" | undefined


    function getXForMomentIndex(momentIndex: number, scale: Scale, distance: number[], time: number[]) {

        var valueToFind = 0;
        if (scale === 'DISTANCE') {
            valueToFind = distance[momentIndex];

        } else {
            //scale = time
            valueToFind = time[momentIndex]
        }

        return valueToFind;
    }

    const destroySvg = (chart: any) => {
        if (chart && chart?.hasOwnProperty('svg')) {
            chart?.svg?.foreach((s: any) => s?.destroy())
            chart.svg = []
        }
    }
    const addFinishLine = (
        value: number | null,
        scale: Scale,
        distance: number[],
        time: number[],
        chart?: any,
    ) => {
        if (chart && isNumber(value)) {
            const xValue = getXForMomentIndex(value, scale, distance, time);
            if (isNaN(xValue)) return;

            const sizeOfLine = 2;

            const xPixel = chart.xAxis[0].toPixels(xValue);
            const yStart = chart.plotTop;
            const yEnd = chart.plotTop + chart.plotHeight;

            const tmpLine = chart.renderer
                .path(['M', xPixel, yStart, 'V', yEnd])
                .attr({
                    fill: '#FFFFFF',
                    stroke: 'black',
                    'stroke-width': sizeOfLine,
                    'stroke-dasharray': sizeOfLine,
                    zIndex: 4
                })
                .add();

            const tmpLine2 = chart.renderer
                .path(['M', xPixel, yStart + sizeOfLine, 'V', yEnd + sizeOfLine])
                .attr({
                    fill: '#FFFFFF',
                    stroke: 'white',
                    'stroke-width': sizeOfLine,
                    'stroke-dasharray': sizeOfLine,
                    zIndex: 4
                })
                .add();

            const tmpLine3 = chart.renderer
                .path(['M', xPixel + sizeOfLine, yStart, 'V', yEnd])
                .attr({
                    fill: '#FFFFFF',
                    stroke: 'white',
                    'stroke-width': sizeOfLine,
                    'stroke-dasharray': sizeOfLine,
                    zIndex: 4
                })
                .add();

            const tmpLine4 = chart.renderer
                .path(['M', xPixel + sizeOfLine, yStart + sizeOfLine, 'V', yEnd + sizeOfLine])
                .attr({
                    fill: '#FFFFFF',
                    stroke: 'black',
                    'stroke-width': sizeOfLine,
                    'stroke-dasharray': sizeOfLine,
                    zIndex: 4
                })
                .add();

            const svg = [tmpLine, tmpLine2, tmpLine3, tmpLine4];
            set(chart, 'svgs', svg);
            return svg;
        }
    };


    return {
        addFinishLine
    }
}